export default () => {
  window.elementorFrontend.hooks.addAction(
    'frontend/element_ready/stb-catalog-carousel-widget.default',
    function ($element) {
      const asyncSwiper = window.elementorFrontend.utils.swiper //using swiper of elementor

      if ($('.stb-catalog-carousel__inner', $element).length) {
        const sliderConfig = $('.stb-catalog-carousel__inner', $element).data('slider')

        const breakpointMobile = {
          slidesPerView: sliderConfig.column_mobile,
          spaceBetween: sliderConfig.gutter_mobile,
        }

        const breakpointTablet = {
          slidesPerView: sliderConfig.column_tablet,
          spaceBetween: sliderConfig.gutter_tablet,
        }

        const breakpointDesktop = {
          slidesPerView: sliderConfig.column,
          spaceBetween: sliderConfig.gutter,
        }

        const swipeConfig = {
          loop: sliderConfig.loop === 'yes' ? true : false,
          navigation: {
            nextEl: `.elementor-element-${$($element).data('id')} .stb-product-catalog__next`,
            prevEl: `.elementor-element-${$($element).data('id')} .stb-product-catalog__prev`,
          },
          pagination: {
            el: `.elementor-element-${$($element).data('id')} .stb-product-catalog__pagination`,
            type: 'fraction',
          },
          breakpoints: {
            // when window width is >= 320px
            320: breakpointMobile,
            // when window width is >= 640px
            640: breakpointTablet,
            // when window width is >= 992px
            1000: breakpointDesktop,
          },
        }

        if (sliderConfig.auto_play === 'yes') {
          swipeConfig.autoplay = {
            delay: sliderConfig.auto_play_speed || 2000,
          }
        }

        new asyncSwiper($('.stb-catalog-carousel__inner', $element), swipeConfig)
      }
    }
  )
}